module.exports = __webpack_public_path__ + "img/xcsb_img.0d2adeee.png";